import httpUtil from '@/utils/axios'

export const WorkOrderCategoriesAPI = {
  list: (params = {}) => httpUtil.get('/work-order-categories', params),
  getById: (id) => httpUtil.get(`/work-order-categories/${id}`),
  create: (payload) => httpUtil.post('/work-order-categories', payload),
  update: (id, payload) => httpUtil.put(`/work-order-categories/${id}`, payload),
  deleteById: (id) => httpUtil.delete(`/work-order-categories/${id}`)
}

export default WorkOrderCategoriesAPI
